import firebase from "firebase/app";
require("firebase/database");
require("firebase/functions")
require("firebase/auth");

/**
 * Firebase config ToDo: 環境変数化
 */

const config = {
  apiKey: process.env.VUE_APP_FIREBAE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBAE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBAE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBAE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBAE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBAE_MESSAGING_SENDERID
};
firebase.initializeApp(config);
const auth = firebase.auth();
const db = firebase.database();
const functions = firebase.functions();

export { firebase, auth, db, functions };